/**
 * Storage keys of the Dealer ID selection.
 *
 * This module has no imports on purpose: `utils/auth/index.ts` clears these keys on logout and must not
 * pull in `dealerSelection.ts`, which imports `state/session`. The strings are a contract with data
 * already stored in browsers and with the plain-JS E2E restore script, so they never change.
 */

/** sessionStorage: the Dealer ID committed for this login. */
export const DEALER_ID_STORAGE_KEY = 'auth:dealerId';

/** sessionStorage: the Dealer IDs ruled out this visit, with the error code that ruled them out. */
export const UNAVAILABLE_DEALER_IDS_STORAGE_KEY = 'auth:unavailableDealerIds';

/** sessionStorage: the Dealer ID an integrator passed to E3D.init() and the login it is locked to. */
export const INTEGRATOR_DEALER_LOCK_STORAGE_KEY = 'auth:integratorDealerLock';

/** localStorage: the last confirmed Dealer ID, a cross-entrance pre-selection hint only. */
export const LAST_CONFIRMED_DEALER_ID_STORAGE_KEY = 'dealerSelection:lastConfirmedDealerId';
